import { API_BASE_URL } from './const';

class Api {
    constructor({ baseUrl }) {
        this._baseUrl = baseUrl;
    }
    
    _checkResponse(res) {
        if (res.ok) {
            return res.json();
        } else {
            return Promise.reject(`Ошибка: ${res.status}`);
        }
    }
    getKp(number) {
        return fetch(`${this._baseUrl}/kp/${number}`, {
            headers: {}
        })
            .then(this._checkResponse)
    }

    getLastKps() {
        return fetch(`${this._baseUrl}/kp/latest`, { method: 'GET' })
            .then(this._checkResponse);
    }

    getLastKpNumber() {
        return fetch(`${this._baseUrl}/kp/lastKpNumber?t=${Date.now()}`, {
            headers: {}
        })
            .then(this._checkResponse)
    }
    addKp(kp) {
        return fetch(`${this._baseUrl}/kp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(kp)
        })
            .then(this._checkResponse);
    }

    updateKp(formData, kpNumber) {
        return fetch(`${this._baseUrl}/kp/${kpNumber}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(this._checkResponse);
    }

    updateKpStatus(kpNumber, status) {
        return fetch(`${this._baseUrl}/kp/${kpNumber}/status`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ status })
        })
            .then(this._checkResponse);
    }

    deleteKp(id) {
        return fetch(`${this._baseUrl}/kp/${id}`, {
            method: 'DELETE'
        }).then(this._checkResponse);
    }

    addList(list) {
        return fetch(`${this._baseUrl}/list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(list)
        })
            .then(this._checkResponse);
    }
    addRow(row) {
        return fetch(`${this._baseUrl}/row`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(row)
        })
            .then(this._checkResponse);
    }
    deleteEvent(id) {
        return fetch(`${this._baseUrl}/event/${id}`, {
            method: 'DELETE',
            headers: {}
        }).then(this._checkResponse);
    }

    propagateEventLogistics(id, payload) {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/events/${id}/propagate`, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(payload)
        }).then(this._checkResponse);
    }
    deleteList(id) {
        return fetch(`${this._baseUrl}/list/${id}`, {
            method: 'DELETE',
            headers: {},
        })
            .then(this._checkResponse);
    }
    deleteRow(id) {
        return fetch(`${this._baseUrl}/row/${id}`, {
            method: 'DELETE',
            headers: {},
        })
            .then(this._checkResponse);
    }
    updateRow(row) {
        return fetch(`${this._baseUrl}/row/update`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(row)
        })
            .then(this._checkResponse);
    }

    getUser() {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/profile/me`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
            .then(this._checkResponse)
    }

    getContractors(search = '') {
        const token = localStorage.getItem('authToken');
        const url = search 
            ? `${this._baseUrl}/contractors?search=${encodeURIComponent(search)}`
            : `${this._baseUrl}/contractors`;
        return fetch(url, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
            .then(this._checkResponse);
    }

    getContractor(id) {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/contractors/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
            .then(this._checkResponse);
    }

    createContractor(contractorData) {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/contractors`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(contractorData)
        })
            .then(this._checkResponse);
    }

    updateContractor(id, contractorData) {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/contractors/${id}`, {
            method: 'PUT',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(contractorData)
        })
            .then(this._checkResponse);
    }

    deleteContractor(id) {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/contractors/${id}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(this._checkResponse);
    }

    getEvents(search = '') {
        const token = localStorage.getItem('authToken');
        const url = search
            ? `${this._baseUrl}/events?search=${encodeURIComponent(search)}`
            : `${this._baseUrl}/events`;
        return fetch(url, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
            .then(this._checkResponse);
    }

    getOneEvent(id) {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/events/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
            .then(this._checkResponse);
    }

    createEvent(eventData) {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/events`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(eventData)
        })
            .then(this._checkResponse);
    }

    updateEvent(id, eventData) {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/events/${id}`, {
            method: 'PUT',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(eventData)
        })
            .then(this._checkResponse);
    }

    deleteEvent(id) {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/events/${id}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(this._checkResponse);
    }

    getMenuItems(search = '') {
        const token = localStorage.getItem('authToken');
        const url = search
            ? `${this._baseUrl}/menu?search=${encodeURIComponent(search)}`
            : `${this._baseUrl}/menu`;
        return fetch(url, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
            .then(this._checkResponse);
    }

    getOneMenuItem(id) {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/menu/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
            .then(this._checkResponse);
    }

    createMenuItem(menuData) {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/menu`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(menuData)
        })
            .then(this._checkResponse);
    }

    updateMenuItem(id, menuData) {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/menu/${id}`, {
            method: 'PUT',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(menuData)
        })
            .then(this._checkResponse);
    }

    deleteMenuItem(id) {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/menu/${id}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(this._checkResponse);
    }

    // ORGANISATIONS
    getOrganisations(search = '') {
        const token = localStorage.getItem('authToken');
        const url = search
            ? `${this._baseUrl}/organisation?search=${encodeURIComponent(search)}`
            : `${this._baseUrl}/organisation`;
        return fetch(url, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
            .then(this._checkResponse);
    }

    getOneOrganisation(id) {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/organisation/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        })
            .then(this._checkResponse);
    }

    createOrganisation(orgData) {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/organisation`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(orgData)
        })
            .then(this._checkResponse);
    }

    updateOrganisation(id, orgData) {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/organisation/${id}`, {
            method: 'PUT',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(orgData)
        })
            .then(this._checkResponse);
    }

    deleteOrganisation(id) {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/organisation/${id}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(this._checkResponse);
    }

    sendFileToBot(kpNumber, blob, fileName, caption) {
        const token = localStorage.getItem('authToken');
        const formData = new FormData();
        formData.append('pdf', blob, fileName);
        if (caption) formData.append('caption', caption);
        return fetch(`${this._baseUrl}/kp/${kpNumber}/send-pdf`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`
            },
            body: formData
        })
            .then(this._checkResponse);
    }

    downloadKpXlsx(kpNumber) {
        const token = localStorage.getItem('authToken');
        return fetch(`${this._baseUrl}/kp/${kpNumber}/export/xlsx`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(res => {
            if (res.ok) {
                const contentDisposition = res.headers.get('Content-Disposition');
                let fileName = `KP_${kpNumber}.xlsx`;
                if (contentDisposition) {
                    const match = contentDisposition.match(/filename=(.+)/);
                    if (match) fileName = match[1];
                }
                return res.blob().then(blob => ({ blob, fileName }));
            }
            return res.json().then(err => Promise.reject(err.message || `Ошибка: ${res.status}`));
        });
    }

}
// const API_BASE =
//   (process.env.REACT_APP_API_BASE && process.env.REACT_APP_API_BASE.replace(/\/$/, ''))
//   || (typeof window !== 'undefined' ? `${window.location.origin}/api` : '/api');

// export const MainApi = new Api({
//   baseUrl: API_BASE,
// });
export const MainApi = new Api({
    baseUrl: API_BASE_URL,
    // baseUrl: 'https://kurgi-kp-backend.onrender.com',
});